import React from 'react';
import './Home.css';

const Home = () => (
  <div className="innerBody">
    <div className="shift">
      <h1>Vivian Lai</h1>
      <hr />
      <h3>Full Stack Web Developer</h3>
      <p className="lead">Hello World!</p>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js